"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderItem = void 0;
function renderItem(svgTemplateItem, dataSource) {
    var _a;
    let result = svgTemplateItem;
    const tempArr = svgTemplateItem.split('{');
    for (let item of tempArr) {
        const endIndex = item.indexOf('}');
        if (endIndex < 0)
            continue;
        const key = item.slice(0, endIndex);
        result = result.replace(`{${key}}`, (_a = dataSource[key]) !== null && _a !== void 0 ? _a : '');
    }
    return result;
}
exports.renderItem = renderItem;
function render(svgTemplate, dataSource) {
    const svgContents = [];
    for (let svgTemplateItem of svgTemplate) {
        if (typeof svgTemplateItem === 'string') {
            svgContents.push(renderItem(svgTemplateItem, dataSource));
        }
        else {
            const { content } = svgTemplateItem;
            if (typeof content === 'string') {
                svgContents.push(content);
            }
            else {
                svgContents.push(...content);
            }
        }
    }
    return svgContents.join('\n');
}
exports.default = render;
